import React from 'react';
import PropTypes from 'prop-types';
import { withUser } from 'components/queries/GetUserQuery';
import currencySymbols from 'constants/currencies';
import StyledSelect from 'components/ui/StyledSelect';

const CurrencySelect = ({ isPackageBooking, isGroupBooking, user: { paymentCurrencies }, onSelect, value, className, defaultValue }) => {
  const filteredCurrencies = paymentCurrencies.filter((currency) =>
    isPackageBooking || isGroupBooking ? ['GBP', 'EUR'].includes(currency) : true
  );

  return (
    <StyledSelect
      data-testid="select"
      className={className}
      id="currency-select"
      data-cy="currency-select"
      onChange={(e) => onSelect(e.target.value)}
      defaultValue={defaultValue}
      value={value}
    >
      {filteredCurrencies.map((currency) => (
        <option key={currency} value={currency}>{`${currency} - ${currencySymbols[currency]}`}</option>
      ))}
    </StyledSelect>
  );
};

CurrencySelect.propTypes = {
  onSelect: PropTypes.func,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  user: PropTypes.shape({
    paymentCurrencies: PropTypes.arrayOf(PropTypes.string)
  }),
  className: PropTypes.string,
  isPackageBooking: PropTypes.bool,
  isGroupBooking: PropTypes.bool
};

export default withUser(CurrencySelect);
